export default __webpack_public_path__ + "static/media/qncho-avatar.4eaad6b8.jpg";